'use client';

import { Dispatch, FC, ReactNode, SetStateAction, useState } from 'react';
import { createContext } from 'use-context-selector';

import { checkContext } from '../context-utils';

export const IntialCacheState: CacheType = {
  store: {
    test: 'test',
  },
};

export const CacheContext = createContext<[CacheType, Dispatch<SetStateAction<CacheType>>] | null>(null);

export const setCacheState = (v: [CacheType, Dispatch<SetStateAction<CacheType>>] | null) => {
  v = checkContext<CacheType>(v);
  return v[1];
};

export type ProviderProps = {
  cacheContext: CacheType;
  children: ReactNode;
};

const CacheProvider: FC<ProviderProps> = ({ cacheContext, children }) => {
  const [appState, dispatch] = useState<CacheType>(cacheContext);

  return <CacheContext.Provider value={[appState, dispatch]}>{children}</CacheContext.Provider>;
};

export default CacheProvider;
